<template>
  <div>
    <v-select
      v-model="wizard.settings.defaultLanguageId"
      :items="languageList"
      v-bind:label="$t('Language')"
      item-text="text"
      item-value="id"
      :error-messages="defaultLanguageIdErrors"
      @change="validator.wizard.settings.defaultLanguageId.$touch()"
      @blur="validator.wizard.settings.defaultLanguageId.$touch()"
    ></v-select>
    <v-row>
      <v-col cols="12" md="6">
        <v-select
          v-model="wizard.settings.defaultTimezone"
          :items="timeZoneList"
          v-bind:label="$t('TimeZone')"
          item-text="text"
          item-value="id"
          :error-messages="defaultTimezoneErrors"
          @change="validator.wizard.settings.defaultTimezone.$touch()"
          @blur="validator.wizard.settings.defaultTimezone.$touch()"
        ></v-select>
      </v-col>
      <v-col cols="12" md="6">
        <v-select
          v-model="wizard.settings.defaultDateFormat"
          :items="dateFormatList"
          v-bind:label="$t('DateFormat')"
          item-text="text"
          item-value="id"
          :error-messages="defaultDateFormatErrors"
          @change="validator.wizard.settings.defaultDateFormat.$touch()"
          @blur="validator.wizard.settings.defaultDateFormat.$touch()"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-select
          v-model="wizard.settings.defaultThousandSeparator"
          :items="thousandSeparatorList"
          v-bind:label="$t('ThousandSeparator')"
          item-text="text"
          item-value="id"
          :error-messages="defaultThousandSeparatorErrors"
          @change="validator.wizard.settings.defaultThousandSeparator.$touch()"
          @blur="validator.wizard.settings.defaultThousandSeparator.$touch()"
        ></v-select>
      </v-col>
      <v-col cols="12" md="6">
        <v-select
          v-model="wizard.settings.defaultDecimalSeparator"
          :items="decimalSeparatorList"
          v-bind:label="$t('DecimalSeparator')"
          item-text="text"
          item-value="id"
          :error-messages="defaultDecimalSeparatorErrors"
          @change="validator.wizard.settings.defaultDecimalSeparator.$touch()"
          @blur="validator.wizard.settings.defaultDecimalSeparator.$touch()"
        ></v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import UserService from "@/services/UserService";

export default {
  props: {
    wizard: {
      type: Object,
      default: () => ({}),
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {},
  created() {
    UserService.getLanguageList().then((data) => {
      this.languageList = data;
    });

    UserService.getTimeZoneList().then((data) => {
      this.timeZoneList = data;
    });

    UserService.getDateFormatList().then((data) => {
      this.dateFormatList = data;
    });

    UserService.getDecimalSeparatorList().then((data) => {
      this.decimalSeparatorList = data;
    });

    UserService.getThousandSeparatorList().then((data) => {
      this.thousandSeparatorList = data;
    });
  },
  data() {
    return {
      languageList: [],
      timeZoneList: [],
      dateFormatList: [],
      decimalSeparatorList: [],
      thousandSeparatorList: [],
    };
  },
  computed: {
    defaultLanguageIdErrors() {
      const errors = [];
      if (!this.validator.wizard.settings.defaultLanguageId.$dirty) return errors;
      !this.validator.wizard.settings.defaultLanguageId.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
    defaultTimezoneErrors() {
      const errors = [];
      if (!this.validator.wizard.settings.defaultTimezone.$dirty) return errors;
      !this.validator.wizard.settings.defaultTimezone.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
    defaultDateFormatErrors() {
      const errors = [];
      if (!this.validator.wizard.settings.defaultDateFormat.$dirty)
        return errors;
      !this.validator.wizard.settings.defaultDateFormat.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
    defaultDecimalSeparatorErrors() {
      const errors = [];
      if (!this.validator.wizard.settings.defaultDecimalSeparator.$dirty)
        return errors;
      !this.validator.wizard.settings.defaultDecimalSeparator.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
    defaultThousandSeparatorErrors() {
      const errors = [];
      if (!this.validator.wizard.settings.defaultThousandSeparator.$dirty)
        return errors;
      !this.validator.wizard.settings.defaultThousandSeparator.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
  },
  methods: {},
};
</script>

<style>
</style>